import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Text } from '@chatterbug/aaron'

import Pressable from 'src/ui/Pressable/Pressable'
import { t } from 'src/lib/i18n-react'
import Badge from 'src/components/CEFRSeal/CEFRSeal'
import LiveDate from 'src/components/LiveDate'

const completionText = (date) => {
  return (
    <>
      {t('Completed at: ')}
      <LiveDate date={date} format="cb_MMMDYYYY" />
    </>
  )
}

const CertListItem = ({
  cefrLevel,
  progress,
  completedAt,
  description,
  linkUrl,
}) => {
  return (
    <Pressable linkUrl={linkUrl} display="flex" flex="1">
      <Box width="32px" mr="2x" alignSelf="center">
        <Badge cefrLevel={cefrLevel} progress={progress} />
      </Box>
      <Flex flexDirection="column">
        <Text
          fontSize="xs"
          fontWeight="bold"
          color={completedAt ? 'black' : 'gray60'}
        >
          {t(`%{level} - %{description}`, {
            level: cefrLevel.toUpperCase(),
            description: description,
          })}
        </Text>
        <Text variant="text.subtitle">
          {completedAt ? completionText(completedAt) : t('In progress')}
        </Text>
      </Flex>
    </Pressable>
  )
}

CertListItem.propTypes = {
  cefrLevel: PropTypes.string.isRequired,
  completedAt: PropTypes.string,
  description: PropTypes.string.isRequired,
  linkUrl: PropTypes.string,
  progress: PropTypes.number.isRequired,
}

export default CertListItem
